import { ccv2Fetch, getCcv2ApiBase, getCcv2TenantId, getCcv2Token } from './index';

const BASE = '/v2/callcenter/campaigns';
const DNC_BASE = '/v2/callcenter/dnc';

const withQuery = (path, params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') search.append(key, String(value));
  });
  const qs = search.toString();
  return qs ? `${path}?${qs}` : path;
};

export const fetchCampaigns = (params = {}) => ccv2Fetch(withQuery(BASE, params));

export const fetchCampaignPermissions = () => ccv2Fetch(`${BASE}/permissions`);

export const fetchCampaignOptions = () => ccv2Fetch(`${BASE}/options`);

export const fetchCampaign = (id) => ccv2Fetch(`${BASE}/${id}`);

export const createCampaign = (dto) =>
  ccv2Fetch(BASE, { method: 'POST', body: JSON.stringify(dto) });

export const updateCampaign = (id, dto) =>
  ccv2Fetch(`${BASE}/${id}`, { method: 'PUT', body: JSON.stringify(dto) });

export const deleteCampaign = (id) => ccv2Fetch(`${BASE}/${id}`, { method: 'DELETE' });

export const applyCampaignAction = (id, action, reason) =>
  ccv2Fetch(`${BASE}/${id}/actions`, {
    method: 'POST',
    body: JSON.stringify(reason ? { action, reason } : { action }),
  });

export const fetchCampaignStats = (id) => ccv2Fetch(`${BASE}/${id}/stats`);

export const fetchCampaignLeads = (id, params = {}) =>
  ccv2Fetch(withQuery(`${BASE}/${id}/leads`, params));

export const fetchCampaignReport = (id, params = {}) =>
  ccv2Fetch(withQuery(`${BASE}/${id}/report`, params));

export const fetchCampaignCompliance = (id, params = {}) =>
  ccv2Fetch(withQuery(`${BASE}/${id}/compliance`, params));

export const fetchRetryRules = (id) => ccv2Fetch(`${BASE}/${id}/retry-rules`);

export const replaceRetryRules = (id, rules) =>
  ccv2Fetch(`${BASE}/${id}/retry-rules`, { method: 'PUT', body: JSON.stringify({ rules }) });

export const fetchCampaignLists = (id) => ccv2Fetch(`${BASE}/${id}/lists`);

export const createCampaignList = (id, dto) =>
  ccv2Fetch(`${BASE}/${id}/lists`, { method: 'POST', body: JSON.stringify(dto) });

export const updateCampaignList = (id, listId, dto) =>
  ccv2Fetch(`${BASE}/${id}/lists/${listId}`, { method: 'PATCH', body: JSON.stringify(dto) });

export const importCampaignList = async (id, listId, file) => {
  const base = await getCcv2ApiBase();
  const token = getCcv2Token();
  const tenantId = getCcv2TenantId();
  const body = new FormData();
  body.append('file', file);

  const res = await fetch(`${base}${BASE}/${id}/lists/${listId}/import?tenant=${tenantId}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'x-tenant-id': tenantId },
    body,
  });

  const payload = await res.json().catch(() => ({ message: res.statusText }));
  if (!res.ok) {
    const err = new Error(payload.message || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = payload;
    throw err;
  }
  return payload;
};

export const downloadCampaignReport = async (id, params = {}) => {
  const base = await getCcv2ApiBase();
  const token = getCcv2Token();
  const tenantId = getCcv2TenantId();
  const search = new URLSearchParams({ tenant: tenantId });
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') search.append(key, String(value));
  });

  const res = await fetch(`${base}${BASE}/${id}/report/export?${search.toString()}`, {
    headers: { Authorization: `Bearer ${token}`, 'x-tenant-id': tenantId },
  });

  if (!res.ok) {
    const payload = await res.json().catch(() => ({ message: res.statusText }));
    const err = new Error(payload.message || `HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }

  const blob = await res.blob();
  const disposition = res.headers.get('Content-Disposition') || '';
  const match = /filename="([^"]+)"/.exec(disposition);
  const filename = match ? match[1] : `campanha-${id}.csv`;
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);

  return { filename, rows: Number(res.headers.get('X-Export-Rows') || 0), truncated: res.headers.get('X-Export-Truncated') === 'true' };
};

export const fetchDnc = (params = {}) => ccv2Fetch(withQuery(DNC_BASE, params));

export const addDnc = (dto) => ccv2Fetch(DNC_BASE, { method: 'POST', body: JSON.stringify(dto) });

export const removeDnc = (phone) =>
  ccv2Fetch(`${DNC_BASE}/${encodeURIComponent(phone)}`, { method: 'DELETE' });

export const importDnc = (phones, reason) =>
  ccv2Fetch(`${DNC_BASE}/import`, { method: 'POST', body: JSON.stringify({ phones, reason }) });
